angular.
module("dx.webapp.examDuration").
component("dxTimeLimit", {
	templateUrl: "tmpl/exam-duration/time-limit-component.html",
	controller: "DxTimeLimitController",
	controllerAs: "vm",
	bindings: {
		showEnableDropdown: "<",
		rightToLeft: "<?",
		// {duration: ns, durationSetting: DX_DURATION_SETTING}
		durationObject: "=",
	},
});
